export function mapboxToken() {
  const meta = document.querySelector('meta[name="mapbox-api-key"]')
  return (meta && meta.content) || ""
}
